module.exports = "input::-webkit-outer-spin-button,\r\ninput::-webkit-inner-spin-button {\r\n  -webkit-appearance: none;\r\n  margin: 0;\r\n}\r\n\r\ninput[type=number] {\r\n    -moz-appearance: textfield;\r\n  }"


//////////////////
// WEBPACK FOOTER
// ./src/app/order-edit/order-edit.component.css
// module id = ./src/app/order-edit/order-edit.component.css
// module chunks = main